module.exports = __webpack_public_path__ + "static/media/ball_e.e300f2ab.png";